var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-sheet",
    {
      staticClass: "max-width rounded-lg",
      style: {
        overflow: "hidden",
        border: !_vm.isFuture ? "1px solid #f5f5f7" : "none",
      },
    },
    [
      !(
        Number(_vm.Master.is_late) ||
        Number(_vm.Master.is_early_leave) ||
        Number(_vm.Master.is_absense) ||
        Number(_vm.Master.is_missing_punch) ||
        Number(_vm.Master.is_ot)
      )
        ? _c(
            "v-sheet",
            { staticClass: "max-width transparent" },
            [
              _vm.Master && !_vm.isFuture
                ? _c(
                    "v-sheet",
                    {
                      staticClass: "max-width rounded-lg d-flex justify-start",
                      attrs: {
                        tile: "",
                        elevation: 0,
                        color:
                          Number(_vm.Master.is_late) ||
                          Number(_vm.Master.is_early_leave) ||
                          Number(_vm.Master.is_absense) ||
                          Number(_vm.Master.is_missing_punch) ||
                          Number(_vm.Master.is_ot)
                            ? "black"
                            : "green",
                        height: 4,
                      },
                    },
                    [
                      _c("v-sheet", {
                        attrs: {
                          width: "20%",
                          height: "100%",
                          color: Number(_vm.Master.is_late)
                            ? _vm.getColors("is_late_1")
                            : "transparent",
                        },
                      }),
                      _c("v-sheet", {
                        attrs: {
                          width: "20%",
                          height: "100%",
                          color: Number(_vm.Master.is_ot)
                            ? _vm.getColors("is_ot_1")
                            : "transparent",
                        },
                      }),
                      _c("v-sheet", {
                        attrs: {
                          width: "20%",
                          height: "100%",
                          color: Number(_vm.Master.is_early_leave)
                            ? _vm.getColors("is_early_leave_1")
                            : "transparent",
                        },
                      }),
                      _c("v-sheet", {
                        attrs: {
                          width: "20%",
                          height: "100%",
                          color: Number(_vm.Master.is_absense)
                            ? _vm.getColors("is_absense_1")
                            : "transparent",
                        },
                      }),
                      _c("v-sheet", {
                        attrs: {
                          width: "20%",
                          height: "100%",
                          color: Number(_vm.Master.is_missing_punch)
                            ? _vm.getColors("is_missing_punch_1")
                            : "transparent",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _c(
            "v-tooltip",
            {
              attrs: { bottom: "", color: "rgba(0,0,0,0.4)" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function (ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _vm.Master && !_vm.isFuture
                        ? _c(
                            "v-sheet",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass:
                                    "max-width rounded-lg d-flex justify-start",
                                  attrs: {
                                    tile: "",
                                    elevation: 0,
                                    color:
                                      Number(_vm.Master.is_late) ||
                                      Number(_vm.Master.is_early_leave) ||
                                      Number(_vm.Master.is_absense) ||
                                      Number(_vm.Master.is_missing_punch) ||
                                      Number(_vm.Master.is_ot)
                                        ? "black"
                                        : "green",
                                    height: 4,
                                  },
                                },
                                "v-sheet",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _c("v-sheet", {
                                staticClass: "flex-shrink-1",
                                attrs: {
                                  width: "20%",
                                  height: "100%",
                                  color: Number(_vm.Master.is_late)
                                    ? _vm.getColors("is_late_1")
                                    : "transparent",
                                },
                              }),
                              _c("v-sheet", {
                                staticClass: "flex-shrink-1",
                                attrs: {
                                  width: "20%",
                                  height: "100%",
                                  color: Number(_vm.Master.is_early_leave)
                                    ? _vm.getColors("is_early_leave_1")
                                    : "transparent",
                                },
                              }),
                              _c("v-sheet", {
                                staticClass: "flex-shrink-1",
                                attrs: {
                                  width: "20%",
                                  height: "100%",
                                  color: Number(_vm.Master.is_ot)
                                    ? _vm.getColors("is_ot_1")
                                    : "transparent",
                                },
                              }),
                              _c("v-sheet", {
                                staticClass: "flex-shrink-1",
                                attrs: {
                                  width: "20%",
                                  height: "100%",
                                  color: Number(_vm.Master.is_absense)
                                    ? _vm.getColors("is_absense_1")
                                    : "transparent",
                                },
                              }),
                              _c("v-sheet", {
                                staticClass: "flex-shrink-1",
                                attrs: {
                                  width: "20%",
                                  height: "100%",
                                  color: Number(_vm.Master.is_missing_punch)
                                    ? _vm.getColors("is_missing_punch_1")
                                    : "transparent",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "rounded-lg d-flex flex-row justify-start pa-0",
                  attrs: { color: "transparent" },
                },
                [
                  _c(
                    "v-sheet",
                    { staticClass: "transparent d-flex align-center px-1" },
                    [
                      _c("svg-icon", {
                        attrs: {
                          size: "16",
                          fill: _vm.getColors("is_late_1"),
                          iconClass: "LabeledColour",
                        },
                      }),
                      _c("span", { staticClass: "white--text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("label_essweb_system_tag_label_lateLabel")
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-sheet",
                    { staticClass: "transparent d-flex align-center px-1" },
                    [
                      _c("svg-icon", {
                        attrs: {
                          size: "16",
                          fill: _vm.getColors("is_early_leave_1"),
                          iconClass: "LabeledColour",
                        },
                      }),
                      _c("span", { staticClass: "white--text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "label_essweb_system_tag_label_earlyLeaveLabel"
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-sheet",
                    { staticClass: "transparent d-flex align-center px-1" },
                    [
                      _c("svg-icon", {
                        attrs: {
                          size: "16",
                          fill: _vm.getColors("is_ot_1"),
                          iconClass: "LabeledColour",
                        },
                      }),
                      _c("span", { staticClass: "white--text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("label_essweb_system_tag_label_otLabel")
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-sheet",
                    { staticClass: "transparent d-flex align-center px-1" },
                    [
                      _c("svg-icon", {
                        attrs: {
                          size: "16",
                          fill: _vm.getColors("is_absense_1"),
                          iconClass: "LabeledColour",
                        },
                      }),
                      _c("span", { staticClass: "white--text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("label_essweb_system_tag_label_absenseLabel")
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-sheet",
                    { staticClass: "transparent d-flex align-center px-1" },
                    [
                      _c("svg-icon", {
                        attrs: {
                          size: "16",
                          fill: _vm.getColors("is_missing_punch_1"),
                          iconClass: "LabeledColour",
                        },
                      }),
                      _c("span", { staticClass: "white--text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "label_essweb_system_tag_label_isMissingPunchLabel"
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }